import { render } from "./registerHeader.vue?vue&type=template&id=02cabdca&scoped=true"
import script from "./registerHeader.vue?vue&type=script&lang=js"
export * from "./registerHeader.vue?vue&type=script&lang=js"

import "./registerHeader.vue?vue&type=style&index=0&id=02cabdca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02cabdca"

export default script